// @flow
import en from './en.js'
import es from './es.js'

export { en, es }



// WEBPACK FOOTER //
// ./src/components/Inputs/Country/countryList/index.js